<template>
    <b-row class="match-height">
      <b-col
lg="8"
offset="2"
> <b-card
      title="Return Detail"
    >
        <b-row>
          <b-col cols="12">
            <b-button
              type="button"
              variant="primary"
              class="mr-1"
              @click="previous()"
            >
              <feather-icon
                icon="ArrowLeftIcon"
                size="16"
                class="align-middle"
              />
              Back
            </b-button>
            <div class="devider" />
            </b-col>
        <b-col cols="12">
          <b-form-group
            label="PO Number"
            label-for="po_number"
            label-cols-md="12"
          >
            <b-form-input
              id="po_number"
              v-model="poNumber"
              placeholder="PO Number"
              readonly
            />
          </b-form-group>
          <b-form-group
            label="No Surat Jalan"
            label-for="no_surat_jalan"
            label-cols-md="12"
          >
            <b-form-input
              id="no_surat_jalan"
              v-model="noSuratJalan"
              placeholder="No Surat Jalan"
              readonly
            />
          </b-form-group>
        <b-form-group>
          <label for="no_invoice">Items :</label>
        </b-form-group>
        <b-form-group>
          <br>
           <div>
          <b-row>
            <b-col
cols="6"
class="text-center font-weight-bold"
>
              Item name
            </b-col>
            <b-col
cols="6"
class="text-center font-weight-bold"
>
              Returned Qty
            </b-col>
            </b-row>
           <p />
          <b-row
v-for="(item) in items"
:key="item.return_detail_item_id"
>
          <br>
            <b-col
cols="6"
class="text-center"
>
                <b-list-group>
                  <b-list-group-item href="#">
{{ item.item.item_name }} ({{ item.item.item_code }})
</b-list-group-item>
                </b-list-group>
              </b-col>
            <b-col
cols="6"
class="text-center"
>
            <b-form-input
              v-model="item.return_detail_item_qty"
              class="text-center"
              readonly
/>
            </b-col>
            <b-col cols="12">
              <br>
            </b-col>
            </b-row>
            </div>
        </b-form-group>
          </b-col>
        </b-row>
    </b-card>
      </b-col>
    </b-row>
  </template>
  <script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import axios from 'axios'
import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      // ✅ DEFINE ALL REACTIVE STATE
      poNumber: '',
      noSuratJalan: '',
      items: [],

      purchaseOrderByPurchasingIsConfirmed: false,
      purchaseOrderByWarehouseIsConfirmed: false,
    }
  },

  mounted() {
    this.getDetail()
  },

  methods: {
    getDetail() {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }

      // ✅ PARSE LOCAL STORAGE CORRECTLY
      const raw = localStorage.getItem('ReturnDetail')
      if (!raw) {
        return
      }

      const item = JSON.parse(raw)

      // ✅ SAFE ACCESS
      this.poNumber = item.purchase_order
        ? item.purchase_order.purchase_order_number
        : '-'

      this.noSuratJalan = item.return_no_surat_jalan || '-'

      const id = item.return_id

      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_RETURN_DETAILS}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success) {
            // ✅ REACTIVE ASSIGNMENT
            this.items = response.data.data || []

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Data Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
            this.toastError('Fetching Data failed')
          }
        })
        .catch(() => {
          this.toastError('Fetching Data failed')
        })
    },

    toastError(text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: text,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    },

    previous() {
      this.$router.push({ name: 'apps-returns-list' })
    },

    dateSimple(value, format = 'YYYY-MM-DD') {
      if (!value) return null
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },
  },
}
</script>